import { render, staticRenderFns } from "./LawNormFormArticle.vue?vue&type=template&id=53186c7f"
import script from "./LawNormFormArticle.vue?vue&type=script&lang=js"
export * from "./LawNormFormArticle.vue?vue&type=script&lang=js"
import style0 from "./LawNormFormArticle.vue?vue&type=style&index=0&id=53186c7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports